import { createTheme } from "@material-ui/core/styles";
import { Overrides as CoreOverrides } from "@material-ui/core/styles/overrides";

// Need to instantiate new one to access to breakpoint in the primary theme
const defaultTheme = createTheme();

type Overrides = CoreOverrides & {
  MuiTimelineItem: any;
};

const overrides: Overrides = {
  MuiButton: {
    root: {
      borderRadius: 50,
      textTransform: "none",
      paddingLeft: 50,
      paddingRight: 50,
      height: 48,
    },
    containedPrimary: {
      color: "#005646",
      fontWeight: 500,
      fontSize: 18,
      boxShadow: "none",
      "&:hover": {
        boxShadow: "0px 2px 22px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#f59bbb",
      },
    },
    containedSecondary: {
      color: "#005646",
      fontWeight: 700,
      fontSize: 19,
      padding: "11px 24px",
      backgroundColor: "white",
      border: "2px solid #005646",
      transform: "translateY(0px)",
      transition: "all 200ms",
      boxShadow: "1px 2px #005646",
      "&:hover": {
        boxShadow: "3px 6px #005646",
        backgroundColor: "white",
        transform: "translateY(-3px)",
        transition: "all 400ms",
      },
    },
  },
  MuiCheckbox: {
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
      "& .MuiCheckbox-colorSecondary .Mui-checked": {
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  },
  MuiTimelineItem: {
    missingOppositeContent: {
      "&:before": {
        display: "none",
      },
    },
  },
};

export default createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  overrides: overrides,
  palette: {
    background: {
      default: "white",
    },
    primary: {
      main: "#f59bbb",
      light: "#f59bbb",
      dark: "#ecafaf",
    },
    secondary: {
      main: "#005646",
      light: "#00564638",
      dark: "#073331",
      contrastText: "#a4e7db",
    },
    success: {
      main: "#CBF5AB",
    },
    yellow: "#FFD747",
    yellow200: "#FFE58A",
    green: "#A4E7DB",
    darkGreen: "#005646",
    inputBorder: "#DBDFE8",
    containerGrey: "#F6F6F6",
    black500: {
      main: "#3E3E3E",
    },
    grey700: {
      main: "#787878",
    },
    grey500: {
      main: "#ABABAB",
    },
    grey300: {
      main: "#D7D7D7",
    },
    grey200: {
      main: "#F7F8FC",
    },
    turquoise: {
      main: "#1A8E96",
      light: "#edfbfc",
    },
    pink700: {
      main: "#FF757B",
    },
    text: {
      primary: "#1B1E1C",
      secondary: "#3E3E3E",
      disabled: "#ABABAB",
      success: "#81D89F",
      turquoise: "#1A8E96",
      noResult: "#787878",
      greyHome: "#D7D7D7",
    },
  },
  typography: {
    fontFamily: ["GT Welsheim Pro", "Arial", "sans-serif"].join(","),
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
      fontWeight: 900,
      fontSize: "44px",
      lineHeight: "110%",

      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: "32px",
        lineHeight: "100%",
      },
    },
    h2: {
      fontWeight: 500,
      fontSize: "26px",
      lineHeight: "120%",
    },
    subtitle1: {
      color: "#ABABAB",
    },
    h3: {
      fontWeight: 500,
      fontSize: "22px",
      lineHeight: "120%",
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: "22px",
      },
    },
    body1: {
      fontSize: "19px",
      lineHeight: "120%",
    },
    body2: {
      fontSize: "16px",
      lineHeight: "120%",
    },
    caption: {
      fontSize: "13px",
      lineHeight: "140%",
      fontWeight: 400,
      color: "#ABABAB",
    },
  },
});

declare module "@material-ui/core/styles/createPalette" {
  interface TypeText {
    success: string;
    turquoise: string;
    noResult: string;
    greyHome: string;
  }

  interface Palette {
    pink700: {
      main: string;
    };
    black500: {
      main: string;
    };
    grey700: {
      main: string;
    };
    grey500: {
      main: string;
    };
    grey300: {
      main: string;
    };
    grey200: {
      main: string;
    };
    turquoise: {
      main: string;
      light: string;
    };
    yellow: string;
    yellow200: string;
    darkGreen: string;
    green: string;
    inputBorder: string;
    containerGrey: string;
  }
  interface PaletteOptions {
    pink700: {
      main: string;
    };
    grey700: {
      main: string;
    };
    grey500: {
      main: string;
    };
    grey300: {
      main: string;
    };
    grey200: {
      main: string;
    };
    turquoise: {
      main: string;
      light: string;
    };
    black500: {
      main: string;
    };
    yellow: string;
    yellow200: string;
    green: string;
    inputBorder: string;
    containerGrey: string;
    darkGreen: string;
  }
}
